import { FormProvider } from 'react-hook-form'

import { Button, Card, Form, Stack, Toast } from '@shopify/polaris'

import { useAccountSettingsForm } from '../hooks/useAccountSettingsForm'
import { segment } from '../util/createSegmentPicker'
import { getTranslation } from '../util/getTranslation'
import { useAuth } from './AuthContext'

import { SettingsContactCard } from './SettingsContactCard'
import { SettingsLanguage } from './SettingsLanguage'
import { SettingsPaymentLabel } from './SettingsPaymentLabel'
import { getComGateLanguageOptions } from '../util/getLanguageOptions'

ComGateAccountSettings.segment = segment('comgate')

export function ComGateAccountSettings() {
  const config = useAuth()
  const { form, saveStatus, setSaveStatus, onSubmit } = useAccountSettingsForm((api, formValues) =>
    api.saveConfig(formValues),
  )

  if (config.account.activationStatus === 'new') {
    // Don't bother user with too much stuff initially
    return null
  }

  return (
    <Card title={getTranslation('settings.gateway_settings')}>
      <FormProvider {...form}>
        <Form onSubmit={onSubmit}>
          {/* <ComGateSettingsBankAccount /> */}
          <SettingsLanguage languages={getComGateLanguageOptions()} />
          <SettingsContactCard />
          <SettingsPaymentLabel />
          <Card.Section>
            <Stack distribution="trailing">
              <Button primary submit disabled={form.formState.isSubmitting}>
                {getTranslation('common.save_settings')}
              </Button>
            </Stack>
          </Card.Section>
        </Form>
      </FormProvider>
      {saveStatus === 'success' && (
        <Toast content={getTranslation('common.settings_saved')} onDismiss={() => setSaveStatus('submit')} />
      )}
      {saveStatus === 'failure' && (
        <Toast content={getTranslation('common.saving_failed')} error onDismiss={() => setSaveStatus('submit')} />
      )}
    </Card>
  )
}
